// extracted by mini-css-extract-plugin
export default {"container":"SkillPill_container__piGkj"};